import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import {
  shortTextPlaceholder,
  textAnswerCharCount,
} from '../../../lib/text-answer'
import type { SurveyQuestion } from '../../../lib/survey-question.types'
import {
  surveyShortTextCounterRowSx,
  surveyShortTextCounterSx,
  surveyShortTextFieldSx,
  surveyShortTextRootSx,
} from '../../../styles/surveyExecutionStyles'

interface ShortTextQuestionProps {
  readonly question: SurveyQuestion
  readonly value: string | null
  readonly onChange: (value: string) => void
}

export function ShortTextQuestion({ question, value, onChange }: ShortTextQuestionProps) {
  const current = value ?? ''
  const count = textAnswerCharCount(current)
  const maxLength = question.maxLength ?? undefined
  const minLength = question.minLength ?? undefined
  const showCounter = maxLength != null

  return (
    <Box sx={surveyShortTextRootSx} data-testid={`survey-q-${question.id}-short-text`}>
      <TextField
        fullWidth
        value={current}
        placeholder={shortTextPlaceholder(question)}
        onChange={(e) => onChange(e.target.value)}
        inputProps={{
          'data-testid': `survey-q-${question.id}-short-text-input`,
          'aria-label': question.prompt,
          ...(minLength == null ? {} : { minLength }),
          ...(maxLength == null ? {} : { maxLength }),
        }}
        sx={surveyShortTextFieldSx}
      />
      {showCounter ? (
        <Box sx={surveyShortTextCounterRowSx}>
          <Typography
            component="span"
            sx={surveyShortTextCounterSx}
            data-testid={`survey-q-${question.id}-short-text-counter`}
            aria-live="polite"
          >
            {`${count} / ${maxLength}`}
          </Typography>
        </Box>
      ) : null}
    </Box>
  )
}
